<main class="mpd-page">
  <header class="page-header">
    <button
      mat-icon-button
      routerLink="/tests"
      aria-label="Back to tests"
      matTooltip="Back to tests">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="page-title">
      <p>Tests</p>
      <h1>Music Player Daemon</h1>
    </div>

    <button
      mat-icon-button
      type="button"
      (click)="connect()"
      [disabled]="connectionState === 'connecting' || controlInProgress"
      aria-label="Refresh MPD connection"
      matTooltip="Refresh connection">
      <mat-icon [class.spinning]="connectionState === 'connecting'">refresh</mat-icon>
    </button>
  </header>

  <div class="error-banner" role="alert" *ngIf="error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error }}</span>
  </div>

  <div class="workspace">
    <section class="panel connection-panel" aria-labelledby="mpd-connection-heading">
      <div class="panel-header">
        <div>
          <span class="section-label">Server</span>
          <h2 id="mpd-connection-heading">Connection</h2>
        </div>
        <span class="status-badge" [ngClass]="connectionState">
          <span class="status-dot"></span>
          {{ connectionLabel }}
        </span>
      </div>

      <dl class="detail-list">
        <div>
          <dt>Address</dt>
          <dd>{{ endpoint ? endpoint.host + ':' + endpoint.port : 'Configured on server' }}</dd>
        </div>
        <div>
          <dt>MPD version</dt>
          <dd>{{ status?.serverVersion || 'Unavailable' }}</dd>
        </div>
        <div>
          <dt>Last checked</dt>
          <dd>{{ lastChecked ? (lastChecked | date:'shortTime') : 'Not checked' }}</dd>
        </div>
      </dl>

      <button
        mat-stroked-button
        color="primary"
        type="button"
        class="connect-button"
        (click)="connect()"
        [disabled]="connectionState === 'connecting' || controlInProgress">
        <mat-icon>power_settings_new</mat-icon>
        {{ isConnected ? 'Reconnect' : 'Connect' }}
      </button>
    </section>

    <section class="panel player-panel" aria-labelledby="mpd-player-heading">
      <div class="panel-header">
        <div>
          <span class="section-label">Now playing</span>
          <h2 id="mpd-player-heading">{{ status?.song?.title || 'Nothing queued' }}</h2>
        </div>
        <span class="playback-state">{{ playbackLabel }}</span>
      </div>

      <div class="track-summary">
        <div class="track-icon" aria-hidden="true">
          <mat-icon>music_note</mat-icon>
        </div>
        <div class="track-copy">
          <strong>{{ status?.song?.artist || 'No artist' }}</strong>
          <span>{{ status?.song?.album || status?.song?.file || 'No track selected' }}</span>
        </div>
      </div>

      <div class="progress-block">
        <div class="progress-track" aria-hidden="true">
          <span [style.width.%]="playbackProgress"></span>
        </div>
        <div class="progress-time">
          <span>{{ formatTime(status?.elapsed) }}</span>
          <span>{{ formatTime(status?.duration) }}</span>
        </div>
      </div>

      <div class="transport">
        <button
          mat-fab
          color="primary"
          type="button"
          class="transport-button"
          (click)="togglePlayback()"
          [disabled]="!isConnected || controlInProgress"
          [attr.aria-label]="isPlaying ? 'Pause MPD playback' : 'Play MPD playback'"
          [matTooltip]="isPlaying ? 'Pause' : 'Play'">
          <mat-icon>{{ controlInProgress ? 'hourglass_empty' : (isPlaying ? 'pause' : 'play_arrow') }}</mat-icon>
        </button>

        <dl class="player-details">
          <div>
            <dt>Volume</dt>
            <dd>{{ volumeLabel }}</dd>
          </div>
          <div>
            <dt>Queue</dt>
            <dd>{{ status?.playlistLength ?? 0 }} tracks</dd>
          </div>
        </dl>
      </div>
    </section>
  </div>
</main>
